// extracted by mini-css-extract-plugin
module.exports = {"form":"addUserGroupForm_form__1fOum","saveButton":"addUserGroupForm_saveButton__3V4r1 buttons_success__3M0iK buttons_button__1BbpB"};